import React from 'react';
import { useTranslation } from 'react-i18next';
import { useFormState } from 'react-final-form';
import { RepairType } from '../../components/RepairType';
import { FORM_VALUES } from '../../../../../utils/helpers/constants';
import { checkIsFlatCategory } from '../../../../../utils/helpers/common';
import { FormBlockWrapper } from '../FormBlockWrapper';
import { BuildingType } from '../../components/BuildingType';
import { FormTextInput } from '../../components/FormTextInput';
import { AdvertInfo, AdvertInfoSubtitle, AdvertInfoTitle } from './styled';

interface AboutEstateProps {
  isEdit?: boolean;
  title?: string;
  subtitle?: string;
}

export const AboutEstate: React.FC<AboutEstateProps> = ({
  isEdit = false,
  title,
  subtitle
}) => {
  const { t } = useTranslation();
  const { values } = useFormState();

  const isFlat = checkIsFlatCategory(values[FORM_VALUES.categoryId]);
  const categoryHasBuildingType =
    values[FORM_VALUES.categoryValues].hasBuildingType || isFlat;

  const formatAreaValue = (value = '') => {
    return value.toString().replace(/(\.0?)?$/, '');
  };

  const areaPlaceholder = `${t('search.form.area')} ${
    values[FORM_VALUES.categoryValues].areaUnits
  } *`;

  const { areRoomsRequired } = values.categoryValues;
  const roomsPlaceholder = areRoomsRequired
    ? t('new_ad.rooms_amount')
    : t('new_ad.rooms_amount').replace(' *', '');

  return (
    <FormBlockWrapper header={!isEdit && t('new_ad.about_estate')} required>
      {isEdit && (
        <AdvertInfo>
          {title && (
            <AdvertInfoTitle data-cy="edit-item-header" tag="title_1">
              {title}
            </AdvertInfoTitle>
          )}
          {subtitle && (
            <AdvertInfoSubtitle tag="title_2" data-cy="edit-item-subtitle">
              {subtitle}
            </AdvertInfoSubtitle>
          )}
        </AdvertInfo>
      )}
      {!isEdit && categoryHasBuildingType && <BuildingType isFlat={isFlat} />}

      {values[FORM_VALUES.categoryValues].hasRooms && (
        <FormTextInput
          name={FORM_VALUES.roomsAmount}
          placeholder={roomsPlaceholder}
          inputMode="numeric"
          isEnabledAutoSelectionRange={false}
          hasErrorField
          isFloat={false}
        />
      )}

      <FormTextInput
        name={FORM_VALUES.area}
        placeholder={areaPlaceholder}
        format={formatAreaValue}
        inputMode="numeric"
        isEnabledAutoSelectionRange={false}
        hasErrorField
        isFloat
      />

      {values[FORM_VALUES.categoryValues].hasLandArea && (
        <FormTextInput
          name={FORM_VALUES.landArea}
          inputMode="numeric"
          format={formatAreaValue}
          isEnabledAutoSelectionRange={false}
          placeholder={`${t('search.form.land_area')} *`}
          hasErrorField
          isFloat
        />
      )}
      {(values[FORM_VALUES.categoryValues].hasFloor || isFlat) && (
        <>
          <FormTextInput
            inputMode="numeric"
            name={FORM_VALUES.floor}
            isEnabledAutoSelectionRange={false}
            placeholder={`${t('search.form.floor')} *`}
            hasErrorField
          />

          <FormTextInput
            inputMode="numeric"
            name={FORM_VALUES.totalFloors}
            placeholder={t('new_ad.total_floors')}
            isEnabledAutoSelectionRange={false}
            hasErrorField
          />
        </>
      )}

      {values[FORM_VALUES.categoryValues].hasRepair && <RepairType />}
    </FormBlockWrapper>
  );
};
